import { Navigate, useSearchParams } from 'react-router-dom';
import type { NewWhat } from './EventsPage';

/**
 * The old screens `/nowa-impreza` and `/nowe-wypozyczenie` (the sidebar, bookmarks, links) open the form in the side
 * panel of "Wydarzenia" (owner 2026-10-21 23:31), with the day or days picked in the calendar (`dzien=`, `dni=`).
 */
export function newInPanelUrl(what: NewWhat, params: URLSearchParams): string {
  const next = new URLSearchParams({ nowe: what === 'rental' ? 'wypozyczenie' : '1' });
  for (const key of ['dzien', 'dni'] as const) {
    const value = params.get(key);
    if (value) next.set(key, value);
  }
  return `/wydarzenia?${next.toString()}`;
}

export function NewInPanelRedirect({ what }: { what: NewWhat }) {
  const [params] = useSearchParams();
  return <Navigate to={newInPanelUrl(what, params)} replace />;
}
